












  import { Vue, Component } from 'vue-property-decorator'

  @Component({})
  export default class Bottombar extends Vue {
  }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Bottombar.vue